export default "assets/images/green-texture-66eabff1.jpg";